// extracted by mini-css-extract-plugin
module.exports = {"content":"Signup_content__35gFc","boxes":"Signup_boxes__2zsj4","text":"Signup_text__Ber9G"};